<template>


    <div class="container">

        <div class="handle-box-search">


            <div class="handle-box">
                <el-row class="head-search">

                    <el-col :span="8">
                        <span class="title">渠道名称:</span>
                        <!-- 搜索司机名称-->
                        <el-input v-model="search_data.name" placeholder="请输入渠道名称" class="handle-input mr10"
                                  @keyup.enter.native="searchpackageList" maxlength=11 style="width: 200px"></el-input>
                    </el-col>
                </el-row>


            </div>

            <div>
                <el-button type="primary" icon="el-icon-search" @click="searchpackageList">搜索</el-button>
                <el-button @click="add_isShow=!add_isShow">添加</el-button>
                <el-button icon="el-icon-refresh-right" @click="refresh">刷新</el-button>


            </div>
        </div>



        <!-- 表格 -->
        <el-table :data="tableData" style="width: 100%" ref="multipleTable" header-cell-class-name="table-header">




            <el-table-column prop="id" label="id" width="80">
            </el-table-column>

            <el-table-column prop="name" label="渠道合作商名称" width="150">
            </el-table-column>

            <el-table-column prop="coupon_mode.details.city.name" label="二维码" width="150">
                <template slot-scope="scope">
                    
                    <el-image
                            style="width: 80px; height: 80px; border: 1px solid #eee; border-radius: 5px"
                            :src="scope.row.coupon_package.url"
                            v-if="scope.row.coupon_package.url != ''"
                            :preview-src-list="srcList"
                    >
                    </el-image>
                </template>
            </el-table-column>

            <el-table-column prop="number" label="优惠券礼包发放数量" width="150">
            </el-table-column>

            <el-table-column prop="get_number" label="已领取" width="150">
            </el-table-column>

            <el-table-column label="未领取" width="150">
                <template slot-scope="scope">
                    {{Number(scope.row.number) - Number(scope.row.get_number)}}
                </template>
            </el-table-column>

            <el-table-column prop="content" label="优惠券发放说明" min-width="180">
            </el-table-column>

            <el-table-column label="开启状态" width="100">
                <template slot-scope="scope">
                    <el-tag :type="scope.row.status.val=='0'?'warning':(scope.row.status.val=='1'?'':'danger')">
                        {{scope.row.status.alias}}
                    </el-tag>
                </template>
            </el-table-column>

            <el-table-column label="有效期" width="180">
                <template slot-scope="scope">
                    {{scope.row.start_time.Ymd}} - {{scope.row.end_time.Ymd}}
                </template>
            </el-table-column>

            <el-table-column prop="admin_name" width="150" label="操作人">
            </el-table-column>

            <el-table-column prop="edit_time.YmdHis" width="150" label="最后操作时间">
            </el-table-column>

            <el-table-column label="操作" width="200">
                <template slot-scope="scope">

                    <el-button @click="toReceiveLict(scope.row.package_code)">

                        领取记录

                    </el-button>


                    <el-button type="primary" @click="editCoupon(scope.row.package_code)">

                        编辑

                    </el-button>

                </template>
            </el-table-column>
        </el-table>


        <!-- 分页组件 -->
        <div class="pagination">
            <pages :search_data="search_data" :result_data="result_data" @pages_function="pages_function"></pages>
        </div>

        <!-- 添加组件 -->
        <addCouponPackageList :isShow="add_isShow" @onSubmit="packageList"></addCouponPackageList>

        <!-- 修改优惠券组件 -->
        <editCouponPackageList :isShow="edit_isShow" :data="children_data" @onSubmit="packageList"></editCouponPackageList>

    </div>


</template>

<script>
    var _this;
    import addCouponPackageList from './addCouponPackageList.vue';
    import editCouponPackageList from './editCouponPackageList.vue';
    export default {
        components: {
            addCouponPackageList,
            editCouponPackageList
        },
        data() {
            return {


                // 添加用户信息组件开关
                add_isShow: false,
                edit_isShow:false,

                children_data:'',

                srcList: [],

                // 存放表格数据
                tableData: [],

                //翻页数据
                search_data: {
                    page: 1,
                    limit: 10,
                    name: '',
                },

                result_data: [],
                search_rules: {
                    page: {
                        placeholder: '页码',
                        rules: {
                            required: true,
                            message: '页码需要大于0',
                            regulation: 'gt',
                            rulesData: 0
                        }
                    },
                    limit: {
                        placeholder: '每页个数',
                        rules: {
                            required: true,
                            message: '每页个数需在1-51之内',
                            regulation: 'between',
                            rulesData: [1, 51]
                        }
                    }
                }
            };
        },
        created() {

            _this = this;

            _this.packageList();


        },

        methods: {
            toReceiveLict(code){

                this.$router.push({
                    path: '/couponPackageReceiveLists',
                    query: {
                        package_code: code,
                    }
                 })

            },

            editCoupon(code){
              _this.edit_isShow = !_this.edit_isShow;
              _this.children_data = code;
            },

            selectPages_coupon_function(search_data) {
                _this.coupon_options_data.page = search_data;

                _this.couponList();
            },
            couponList() {
                _this
                    .$post('/coupon/CouponModeLists', _this.coupon_options_data)
                    .then((res) => {
                        _this.selectPages_coupon_data = res;
                        _this.options_coupon_code = res.data;
                    })
                    .catch((err) => {
                    });
            },
            couponChange(val) {
                _this.search_data.coupon_mode_code = val;
            },



            // 查看记录方法
            toDetails(code) {


                this.$router.push({
                    path: 'couponRecordLists',
                    query: {
                        coupon_code: code
                    }
                });

            },


            searchpackageList() {

                _this.search_data.page = 1;
                _this.packageList();

            },




            // 搜索用户管理列表
            packageList() {
                _this.$post(
                    '/package/packageList',
                    _this.search_data,
                    _this.search_rules
                )
                    .then(res => {


                        // 将请求的数据存放到表格数据数组中
                        _this.tableData = res.data;
                        _this.result_data = res;

                        _this.srcList.length = 0;
                        for (let i = 0; i < res.data.length; i++) {
                            _this.srcList.push(res.data[i].coupon_package.url);
                        }


                    }).catch((err) => {

                });
            },
            //翻页组件的回调
            pages_function(search_data) {

                //赋值
                _this.search_data = search_data;
                //初始化列表
                _this.packageList();

            },


            // 刷新按钮
            refresh() {
                this.$router.go(0);
            }


        }
    };
</script>

<style scoped>
    .handle-box {
        margin-bottom: 20px;
    }

    .handle-select {
        width: 120px;
    }

    .handle-input {
        width: 200px;
        display: inline-block;
    }

    .table {
        width: 100%;
        font-size: 14px;
    }

    .red {
        color: #ff0000;
    }

    .mr10 {
        margin-right: 10px;
    }

    .table-td-thumb {
        display: block;
        margin: auto;
        width: 40px;
        height: 40px;
    }

    .el-table__row {
        height: 100px;
    }

    .el-dropdown {
        vertical-align: top;
    }

    .el-dropdown + .el-dropdown {
        margin-left: 15px;
    }

    .el-icon-arrow-down {
        font-size: 12px;
    }
    .img{
        display: block;
        width: 120px;
        height: 120px;
    }
</style>
